import { forwardRef } from 'react';

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type TCardProps = React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>;

export const Card = forwardRef<HTMLDivElement, TCardProps>(
    ({ className, children, ...props }, ref) => {
        return (
            <article
                className={twMerge(
                    classNames(
                        'rounded-m border border-solid border-secondary-90 bg-structure-100 p-l',
                        className
                    )
                )}
                ref={ref}
                {...props}
            >
                {children}
            </article>
        );
    }
);

Card.displayName = 'Card';
